export class BitfStrapiAuth {
  jwt: string;

  constructor(data: { jwt: string }) {
    this.jwt = data.jwt;
  }
}
